import MatrixComponent from "slotworks/components/matrix/matrix-component";
import Layers from "slotworks/graphics/layers/layers";
import SGReelComponent from "./reel/sg-reel-component";
import SGSymbolComponent from "./symbol/sg-symbol-component";
import Point from "slotworks/utils/geom/point";

export default class SGMatrixComponent extends MatrixComponent {

    public LightningLayer: Layers;
    protected createReelComponent(index: number, rows: number, reelstrip: string[], defaultStop: number = 0, matrixLayer: Layers, animationLayer: Layers) {
        return new SGReelComponent(index, rows, reelstrip, defaultStop, matrixLayer, animationLayer);
    }

    protected createSymbolComponent(gridPosition: Point, matrixLayer: Layers, animationLayer: Layers): SGSymbolComponent {
        return new SGSymbolComponent(gridPosition, matrixLayer, animationLayer);
    }

}
